// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CustomDropdown_dropdown__1NPJT"};